export default "__VITE_ASSET__DhKV3591__"